module.exports = __webpack_public_path__ + "static/media/Milton_6.a4b38072.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/Milton_6.jpg
// module id = 482
// module chunks = 0